import ErrorScreen from '@components/v2/layout/ErrorScreen/ErrorScreen';
import OfflineIllustration from '@components/v2/layout/ErrorScreen/svg/OfflineIllustration';
import { RefreshCw, Wifi } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import BannerToBrandUseOffline from './components/BannerToBrandUseOffline/BannerToBrandUseOffline';
import useOfflineWithoutDataPage from './hooks/useOfflineWithoutDataPage';

const OfflineWithoutDataPage = () => {
  const {
    hasSyncedData,
    canEnterInOfflineMode,
    hasOfflineModeAction,
    hasBrandBanner,
    reloadPage,
    goToOfflineMode,
  } = useOfflineWithoutDataPage();

  const reloadAction = {
    label: LangEnum.GLOBAL_RELOAD_THE_PAGE,
    icon: RefreshCw,
    onClick: reloadPage,
  };

  const actions = hasOfflineModeAction
    ? {
        secondary: reloadAction,
        primary: {
          label: LangEnum.GLOBAL_ACCESS_OFFLINE_MODE,
          icon: Wifi,
          disabled: !canEnterInOfflineMode,
          onClick: goToOfflineMode,
        },
      }
    : { primary: reloadAction };

  return (
    <ErrorScreen
      title={{ text: LangEnum.GLOBAL_INTERNET_UNAVAILABLE }}
      illustration={<OfflineIllustration />}
      slots={{ banner: hasBrandBanner ? <BannerToBrandUseOffline /> : undefined }}
      actions={actions}
      description={{
        text: hasSyncedData
          ? LangEnum.OFFLINE_WITH_DATA_DESCRIPTION
          : LangEnum.OFFLINE_WITHOUT_DATA_DESCRIPTION,
      }}
    />
  );
};

export default OfflineWithoutDataPage;
